import { render, staticRenderFns } from "./ForbiddenContainer.vue?vue&type=template&id=15881b9a&scoped=true&"
import script from "./ForbiddenContainer.vue?vue&type=script&lang=js&"
export * from "./ForbiddenContainer.vue?vue&type=script&lang=js&"
import style0 from "./ForbiddenContainer.vue?vue&type=style&index=0&id=15881b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15881b9a",
  null
  
)

component.options.__file = "ForbiddenContainer.vue"
export default component.exports